export default "__VITE_ASSET__guvIzAov__"